import { ChevronDown } from "lucide-react";
import { NOTIFICATION_TABS, inputBaseClass } from "./constants";

export function ApiResponsePre({ ok, text }) {
  if (!text) return null;
  return (
    <pre
      className={`mt-3 p-3 rounded-lg text-xs font-mono whitespace-pre-wrap break-words ${
        ok
          ? "bg-green-50 border border-green-200 text-green-800"
          : "bg-red-50 border border-red-200 text-red-900"
      }`}
    >
      {text}
    </pre>
  );
}

export function SectionCard({ title, subtitle, subtitleClassName = "mb-4", children }) {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6">
      {title ? (
        <h2 className="text-[15px] font-semibold text-gray-900">{title}</h2>
      ) : null}
      {subtitle != null ? (
        <div className={`text-xs text-gray-500 ${subtitleClassName}`}>{subtitle}</div>
      ) : null}
      {children}
    </div>
  );
}

/** Card with title, subtitle, divider, and body — matches webhook add-form mock */
export function FormSectionCard({ title, subtitle, children }) {
  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
      <div className="px-6 pt-5 pb-4">
        <h2 className="text-base font-semibold text-gray-900 tracking-tight">{title}</h2>
        {subtitle ? <p className="mt-1 text-xs leading-relaxed text-gray-500">{subtitle}</p> : null}
      </div>
      <div className="border-t border-gray-200 px-6 py-5">{children}</div>
    </div>
  );
}

export function FormLabel({ children, required = false, htmlFor }) {
  return (
    <label htmlFor={htmlFor} className="block text-xs font-medium text-gray-700 mb-1.5">
      {children}
      {required ? <span className="text-red-500 ml-0.5">*</span> : null}
    </label>
  );
}

export function SelectField({ id, value, onChange, children, className = "", hasError = false }) {
  return (
    <div className="relative">
      <select
        id={id}
        value={value}
        onChange={onChange}
        className={`${inputBaseClass} appearance-none pr-10 cursor-pointer ${
          hasError ? "border-red-400 focus:border-red-500 focus:ring-red-200" : ""
        } ${className}`}
      >
        {children}
      </select>
      <ChevronDown
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400"
        aria-hidden
      />
    </div>
  );
}

export function FixedToast({ toast }) {
  if (!toast) return null;
  return (
    <div
      className={`fixed bottom-6 right-6 z-[1000] px-4 py-3 rounded-lg text-sm font-medium text-white shadow-lg max-w-sm ${
        toast.isError ? "bg-red-600" : "bg-gray-900"
      }`}
    >
      {toast.message}
    </div>
  );
}

export function NotificationTabBar({ activeTab, onTabChange }) {
  return (
    <div className="px-8 pt-4 flex gap-0 border-b border-gray-200 bg-[#FCFCFC]">
      {NOTIFICATION_TABS.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onTabChange(t.id)}
          className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors ${
            activeTab === t.id
              ? "text-blue-600 border-blue-600"
              : "text-gray-500 border-transparent hover:text-blue-600"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
